export const LINK_CLASSNAME =
  'where-a:link-light where-a:text-html-content-rich';
export const CONTENT_CLASSNAME =
  'text-html-content-rich where-span:text-inline-wrap where-a:link-light where-ol:list-ol where-ul:list-ul where-s:line-through';
